<template>
    <div>
        <main class="main-container">
            <div class="left_img"></div>
            <div class="right_text">
                <h3><span @click="toIndex"></span>欢迎登录</h3>
                <el-form :label-position="labelPosition" :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px" class="login-ruleForm">
                    <el-form-item label="账号：" prop="loginName">
                        <el-input type="text" v-model.trim="ruleForm.loginName" clearable auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="密码："  prop="fpassword">
                        <el-input type="password" :maxlength="20" v-model.trim="ruleForm.fpassword" clearable auto-complete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="验证码：" class="vericode" prop="verificationCode">
                        <el-input v-model.trim="ruleForm.verificationCode" clearable></el-input>
                        <img class="veriCodeImg" @click="getVericode" :src="imgSrc"/>
                    </el-form-item>
                    <el-form-item size="large">
                        <el-button type="primary" @click="submitForm('ruleForm')">登录</el-button>
                    </el-form-item>
                </el-form>
                <div class="other">
                    <span class="forgetPass" @click="$router.push('/forget')">忘记密码</span>
                    <p>
                        <span class="helpCenter" @click="toHelp">帮助中心</span>
                        <span class="line"></span>
                        <span class="registerNow" @click="$router.push('/register')">立即注册</span>
                    </p>
                </div>
            </div>
        </main>
        <div class="copyright">版权所有Copyright©2018 ΜΟΜΛ当代节能置业招采平台</div>
    </div>
</template>
<script>
    import md5 from 'js-md5';
    import util from '../../util/index';
    import { loginRules } from '../../util/rules'
    export default {
        name: 'login',
        data() {
            return {
                labelPosition: 'left',
                imgSrc: '',//图片验证码地址；
                ruleForm: {
                    loginName: '',
                    fpassword: '',
                    verificationCode:'',
                    codeKey:''
                },
                rules: loginRules
            }
        },
        mounted(){
            this.getVericode();
        },
        methods: {
            toIndex(){
                this.$root.activeIndex = 'home';
                this.$router.push('/');
            },
            toHelp(){
                this.$root.activeIndex = 'setting';
                this.$router.push('/help');
            },
            getUuid() {
                let s = [];
                let hexDigits = "0123456789abcdef";
                for (let i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4";  // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);  // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "";

                let uuid = s.join("");
                return uuid;
            },
            getVericode(){//获取图片验证码 /rest-api/v1/login/public/restLogin
                let code = this.getUuid();
                this.imgSrc = util.baseUrl + '/v1/login/public/getGraphicCode/'+code;
                this.ruleForm.codeKey = code;
            },
            submitForm(formName) {//提交表单
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                       _this.$root.postHttp('/v1/login/public/restLogin',{
                           "userName": _this.ruleForm.loginName,
                           "password": md5(_this.ruleForm.fpassword),
                           "verificationCode": _this.ruleForm.verificationCode,
                           "codeKey": _this.ruleForm.codeKey,
                       },function(res){
                           _this.$root.isLogin = true;
//                                设置token，用来判断是否登录；
                           window.sessionStorage.setItem('token',res.headers.token);
                           window.sessionStorage.setItem('refresh_token',res.headers.refresh_token);
                           window.sessionStorage.setItem('loginId',res.data.data.suppliersId);
                           window.sessionStorage.setItem('companyName',res.data.data.companyName);
                           if(_this.$route.params.url == 'masterCenter'){
                               _this.$router.push('/master/center');
                           }else{
                               window.location.href = decodeURIComponent(_this.$route.params.url);
                           }

                            // _this.$root.activeIndex = 'home';
                       },function(){
                           _this.getVericode();
                       })
                    } else {
                        _this.$alert('带*的字段必须填写', '提示', {
                            confirmButtonText: '确定',
                            type: 'warning'
                        });
                        return false;
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import "../../assets/_var.scss";

    #login {
        position: relative;
        height: 100vh;
        box-sizing: border-box;
        padding-top: 80px;
        // background: url("../../assets/images/login/bg.jpg") no-repeat 0 0/100% 100%;
        & main {
            width: 882px;
            overflow: hidden;
            & .left_img {
                float: left;
                width: 500px;
                height: 450px;
                background: url("../../assets/images/login/bg.png") no-repeat 0 0/500px auto;
            }
            & .right_text {
                float: left;
                margin-top: 20px;
                padding: 50px 35px;
                background: #fff;
                box-shadow: 0 0 15px rgba(0,0,0,.2);
                & h3 {
                    line-height: 32px;
                    /*padding-left: 210px;*/
                    text-align: left;
                    color: $--text-color;
                    & span {
                        display: inline-block;
                        vertical-align: middle;
                        margin-right: 20px;
                        width: 200px;
                        height: 32px;
                        cursor: pointer;
                        background: url("../../assets/images/topBar1/logoIcon.png") no-repeat 0 0/200px auto;
                    }
                }
                & .el-form {
                    margin-top: 15px;
                    & .el-form-item {
                        border: 1px solid $--secondary-fill-color;
                        border-radius: 3px;
                        & .el-form-item__label::before {
                            content: '';
                            display: inline-block;
                            margin: 0 5px 0 5px;
                            vertical-align: middle;
                            width: 20px;
                            height: 20px;
                            background: url('../../assets/images/login/icon01.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            width: 210px;
                        }
                        & .el-input__inner {
                            border: none;
                            padding: 0;
                        }

                    }
                    & .vericode .el-input__suffix {
                        right: 105px;
                    }
                    & .el-form-item:nth-of-type(2){
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon02.png') no-repeat 0 0;
                        }
                    }
                    & .el-form-item:nth-of-type(3){
                        & .el-form-item__label::before {
                            background: url('../../assets/images/login/icon03.png') no-repeat 0 0;
                        }
                        & .el-form-item__content {
                            position: relative;
                            & .veriCodeImg {
                                position: absolute;
                                right: 10px;
                                top: 3px;
                                cursor: pointer;
                                width: 90px;
                                height: 34px;
                            }
                        }
                    }
                    & .el-form-item:nth-of-type(4) {
                        border: none;
                        & .el-form-item__content {
                            margin-left: 0;
                            & button {
                                width: 312px;
                                margin-left: -100px;
                            }
                        }
                    }
                }
                & .other {
                    overflow: hidden;
                    font-size: 12px;
                    cursor: pointer;
                    & .forgetPass {
                        float: left;
                        color: $--primary-color;
                    }
                    & p {
                        float: right;
                        color: $--text-color-lighter;
                        & .line {
                            margin: 0 8px;
                            border-left: 1px solid $--text-color-lighter;
                        }
                    }
                }
            }
        }
        & .copyright {
           margin-top: 50px;
            font-size: 12px;
            color: $--text-color-lighter;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Login.vue